export default {
    approvals: "Approvazioni",
    delegates: "Delegati",
    employees: "Dipendenti"
}